/**
 * This hook will update the task and set the member as the current user
 */
import { buildGraphqlQuery } from '@ztechapps/common.utils'
import { gql } from '@apollo/client'
import type { UseActionResult } from '@ztechapps/common.hook'
import { useMutation, useUser } from '@ztechapps/common.hook'
import type { Task } from '@ztechapps/common.contract'
import merge from 'lodash/merge'

const fragment = gql`
  fragment TaskFragment on Task {
    _id
    members {
      _id
      profile {
        _id
        name
        picture
        email
      }
    }
  }
`
const taskQueries = buildGraphqlQuery('Task', fragment)

export const useAssignTaskToMe = (): UseActionResult<Task, Task> => {
  const { user } = useUser()

  const [_onAssignTaskToMe, , { loading, error }] = useMutation<{ updateTask: Task }, Task>(taskQueries.updateConfig)

  const onAssignTaskToMe = async (args) => {
    const finalArgs = merge(
      {
        input: {
          members: [
            {
              _id: user._id,
            },
          ],
        },
      },
      args
    )

    const result = await _onAssignTaskToMe(finalArgs)
    return result?.data?.updateTask
  }

  return [onAssignTaskToMe, { loading, error }]
}
